// The detection types enriched_malicious_hashes can carry, in the order a
// report should read them. Shared by the dashboard widget, the flat
// export/PDF table and the JSON/CSV export.
//
// `reason` is the raw string the backend writes on each item; `value` is the
// badge text shown to the user. They differ in casing, so filtering must
// always go through `reason`.
export const TYPE_PRIORITY = [
  {
    key: "fileControl",
    modifier: "file",
    label: "File-Based Detections",
    reason: "File control",
    value: "File Control",
  },
  {
    key: "sigmaMatch",
    modifier: "sigma",
    label: "Sigma Matches",
    reason: "Sigma match",
    value: "Sigma Match",
  },
  {
    key: "memoryControl",
    modifier: "memory",
    label: "Live Processes",
    reason: "Memory control",
    value: "Memory Control",
  },
];

// Falls back to the raw reason so an unrecognised type is still reported.
export const getDetectionType = (reason) =>
  TYPE_PRIORITY.find((type) => type.reason === reason)?.value || reason || null;
